<template>
    <Modal
        buttonClass="attachment-purple"
        buttonText="Bijlagen"
        modalClass="w-2/3"
        ref="modalAttachments"
        v-if="this.$page.props.user.permissions.includes('requests.attachments')"
    >
        <div>
            <Form @submitted="postAttachments" class="max-w-[500px]" enctype="multipart/form-data">
                <h3>Bijlagen</h3>
                <Select
                    label="Type"
                    name="type"
                    :required="true"
                    :options="attachmentTypeOptions"
                    :sortByLabel="false"
                    v-model="formAttachments.type"
                    :error="formAttachments.errors.type"
                />
                <Input
                    label="Sleep bestand(en) hierin of klik hier"
                    name="attachment"
                    type="file"
                    :required="true"
                    :multiple="true"
                    :fileDragDrop="true"
                    heightDragDrop="130"
                    v-model="formAttachments.attachment"
                    :error="formAttachments.errors.attachment"
                />
                <Button
                    text="Bijlage(s) toevoegen"
                    buttonClass="save"
                    type="submit"
                    :loading="formAttachments.processing"
                    class="self-end"
                />
            </Form>
            <h3 class="mt-4">Toegevoegde bijlages</h3>
            <Table :id="'request-attachments-' + request.id" :values="request.attachments">
                <thead>
                <tr>
                    <Th id="type" :sorted="true">Type</Th>
                    <Th id="file">Bestand</Th>
                    <Th id="created_at">Toegevoegd op</Th>
                    <Th id="user.name">Toegevoegd door</Th>
                    <Th id="send">Verzonden</Th>
                    <Th :sort="false"></Th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="attachment in state.sortedValues['request-attachments-' + request.id]" :key="attachment.id">
                    <Td>{{ attachment.type }}</Td>
                    <Td>
                        <a :href="'/requests/' + request.id + '/download-attachment?filename=' + encodeURIComponent(attachment.file)">
                            {{ attachment.file }}
                        </a>
                    </Td>
                    <Td>{{ moment(attachment.created_at).format('DD/MM/YYYY HH:mm') }}</Td>
                    <Td>
                        <template v-if="attachment.user">
                            {{ attachment.user.name }}
                        </template>
                    </Td>
                    <Td class="text-center">
                        <i class="fas fa-check text-blue-dark-500" v-if="attachment.send"></i>
                    </Td>
                    <Td>
                        <Modal buttonClass="info" buttonSize="small" v-if="attachment.send">
                            <h3>Info</h3>
                            <strong>{{ attachment.file }}</strong>
                            <table class="mt-4">
                                <tr>
                                    <th class="text-left pr-4">Ontvanger</th>
                                    <th class="text-left pr-4">Verzonden op</th>
                                </tr>
                                <tr v-for="(attachmentReceiver, key) in attachment.attachment_receivers">
                                    <td class="pr-4">{{ attachmentReceiver.receiver }}</td>
                                    <td>{{ moment(attachmentReceiver.send_at).format('DD/MM/YYYY HH:mm') }}</td>
                                </tr>
                            </table>
                        </Modal>
                        <Button
                            buttonClass="delete"
                            size="small"
                            title="Verwijderen"
                            @click="deleteAttachment(attachment)"
                        />
                    </Td>
                </tr>
                </tbody>
            </Table>
            <h3 class="mt-4">
                Bijlages in map
                <span class="text-sm text-blue-dark-500 font-normal">
                    ({{ attachmentsPath }})
                </span>
            </h3>
            <!--                            Bijlages in hoofdmap-->
            <ul v-if="attachments.length > 0">
                <template v-for="attachment in attachments" :key="attachment">
                    <li v-if="attachment.lastIndexOf('/') === attachmentsPath.length">
                        <a :href="'/requests/' + request.id + '/download-attachment?filename=' + encodeURIComponent(attachment.substring(attachment.lastIndexOf('/') + 1, attachment.length))">
                            {{ attachment.substring(attachmentsPath.length + 1, attachment.length) }}
                        </a>
                    </li>
                    <template v-else>
                        <template :set="attachmentsSubfolder = true"></template>
                    </template>
                </template>
            </ul>
            <!--                            Bijlages in submappen -->
            <div class="mt-2 mb-4" v-if="attachmentsSubfolder">
                <h4>Bijlages in submap(pen)</h4>
                <template v-for="attachment in attachments" :key="attachment">
                    <li v-if="attachment.lastIndexOf('/') > attachmentsPath.length">
                        <a :href="'/requests/' + request.id + '/download-attachment?filename=' + encodeURIComponent(attachment.substring(attachment.lastIndexOf('/') + 1, attachment.length))
                                    + '&submap=' + encodeURIComponent(attachment.substring(attachmentsPath.length + 1, attachment.length - attachment.substring(attachment.lastIndexOf('/') + 1, attachment.length).length))">
                            {{ attachment.substring(attachmentsPath.length + 1, attachment.length) }}
                        </a>
                    </li>
                </template>
            </div>
            <Button
                htmlType="a"
                linkType="normal"
                text="Download alle bijlagen"
                buttonClass="download"
                :href="'/requests/' + request.id + '/download-attachments'"
            />
        </div>
    </Modal>
</template>

<script>
import Button from '@/Components/Button.vue'
import Modal from '@/Components/Modal.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Form from '@/Components/Form.vue'
import Input from '@/Components/Input.vue'
import Select from '@/Components/Select.vue'

import {Inertia} from "@inertiajs/inertia";
import {ref} from "vue";
import {useForm} from "@inertiajs/inertia-vue3";
import moment from "moment";

import store from '@/store'

export default {
    components: {
        Button,
        Modal,
        Form,
        Table,
        Td,
        Th,
        Input,
        Select,
    },
    props: {
        request: {
            required: true
        },
        attachments: {
            required: true
        },
        attachmentTypes: {
            required: true
        },
        attachmentsPath: {
            required: true
        },
    },
    setup(props)
    {
        let modalAttachments = ref(null)
        let attachmentTypeOptions = {}
        let attachmentsSubfolder = false

        console.log(modalAttachments)

        props.attachmentTypes.forEach(function(attachmentType) {
            attachmentTypeOptions[attachmentType] = attachmentType
        })

        const formAttachments = useForm({
            request_id: props.request.id,
            type: null,
            attachment: null,
        })

        function postAttachments()
        {
            formAttachments.post(route('requests.store-attachment'), {
                onError: (data) => {
                    // console.log(data)
                },
                onSuccess: (data) => {
                    formAttachments.reset()

                    if (data.props.flash.error !== null || data.props.flash.warning !== null)
                    {
                        modalAttachments.value.show = false
                    }
                }
            })
        }

        function deleteAttachment(attachment)
        {
            if (!confirm('Bent u zeker dat u deze bijlage wil verwijderen? (' + attachment.file + ')')
            )
                return

            Inertia.delete(route('requests.delete-attachment', { 'attachment': attachment.id }))
        }

        return {
            state: store.state,
            ...store,
            modalAttachments,
            attachmentTypeOptions,
            formAttachments,
            postAttachments,
            deleteAttachment,
            attachmentsSubfolder,
        }
    },
    created: function () {
        this.moment = moment;
    },
}
</script>
